import React, { Component, Fragment } from 'react'
import { withFormik } from 'formik'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import InlineTextInput from '@app/components/ui/inputs/InlineTextInput'
import RadioGroup from '@app/components/ui/inputs/RadioGroup'
import RadioButton from '@app/components/ui/inputs/RadioButton'
import Submit from '@app/components/ui/inputs/Submit'
import InlineSelect from '@app/components/ui/selects/InlineSelect'
import ActionButton from '@app/components/ui/buttons/ActionButton'
import * as Yup from '@app/helpers/yup'
import _ from 'lodash'
import SVG from 'react-inlinesvg'
import pencil from '@icons/pencil/blue'

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    name: Yup.string().required(),

    surname: Yup.string().required(),

    gender: Yup.string().oneOf(['1', '2']).required(),

    grade: Yup.string()
      .when('mode', (mode, schema) => {
        return mode == "parent" ? schema.required() : schema
      })
  }),

  mapPropsToValues: ({ student: { object }, config: { mode } }) => ({
    id: object.id,
    mode: mode,
    name: object.name || '',
    surname: object.surname || '',
    gender: object.gender || '',
    grade: object.grade || '',
  }),

  handleSubmit: (payload, { props }) => {
    const { createStudentAction, updateStudentAction } = props

    if (!payload.id) createStudentAction(payload)
    else updateStudentAction(payload)
  },

  displayName: 'StudentsForm'
});

class Form extends Component {
  constructor(props) {
    super(props)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.student.processing && !this.props.student.processing) {
      let { setSubmitting, resetForm } = this.props
      setSubmitting(false)

      if (!this.props.error) { resetForm() }
    }
  }

  submitButton() {
    const {
      errors,
      isSubmitting,
      submitCount,
      submitForm
    } = this.props;

    return (
      <ActionButton
         className="btn f--upper"
         disabled={submitCount > 0 && !_.isEmpty(errors) || isSubmitting}
         loading={isSubmitting}
         disabled={isSubmitting}
         onClick={(e) => submitForm()}>
        { I18n.t("js.students_table.save") }
      </ActionButton>
    )
  }

  render() {
    const {
      values,
      touched,
      errors,
      handleChange,
      handleBlur,
      setFieldValue,
      isSubmitting,
      number,
      config,
      olympiads,
      student
    } = this.props;

    const remoteErrors = student.validationErrors || {}

    const persisted = !!values.id
    const isEventActive = config.event && !config.event.beforeTrialTour && !config.event.afterMainTour

    return (
      <Fragment>
        <div className="h-flex-layout h-flex-layout--row">
          <div className="students-table__number mr-1">
            {number}.
          </div>
          <InlineTextInput
            autoFocus
            type="text"
            id={`${number}_name`}
            name="name"
            disabled={isSubmitting}
            readOnly={isSubmitting}
            error={touched.name && errors.name || remoteErrors.name}
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={I18n.t("js.students_table.name")}
          />
          <InlineTextInput
            type="text"
            id={`${number}_surname`}
            name="surname"
            disabled={isSubmitting}
            readOnly={isSubmitting}
            error={touched.surname && errors.surname || remoteErrors.surname}
            value={values.surname}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={I18n.t("js.students_table.surname")}
          />
          <RadioGroup error={touched.gender && errors.gender || remoteErrors.gender}>
            <RadioButton
              id={`${number}_gender_male`}
              name={`${number}_gender`}
              checked={values.gender == 1}
              value={1}
              label={ I18n.t('gender.male') }
              disabled={isSubmitting}
              readOnly={isSubmitting}
              onChange={ (e) => setFieldValue('gender', e.target.value) }
              onBlur={handleBlur}
            />
            <RadioButton
              id={`${number}_gender_female`}
              name={`${number}_gender`}
              checked={values.gender == 2}
              value={2}
              label={ I18n.t('gender.female') }
              disabled={isSubmitting}
              readOnly={isSubmitting}
              onChange={ (e) => setFieldValue('gender', e.target.value) }
              onBlur={handleBlur}
            />
          </RadioGroup>
          <div className="hide-mobile">{ this.submitButton() }</div>
        </div>
        <div className="mobile-only">
          <div className="w-flex-layout">{ this.submitButton() }</div>
        </div>
      </Fragment>
    )
  }
}

Form.propTypes = {
  student: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  olympiads: PropTypes.array.isRequired,
  createStudentAction: PropTypes.func.isRequired,
  updateStudentAction: PropTypes.func.isRequired,
  deleteStudentAction: PropTypes.func.isRequired
}

export default formikEnhancer(Form)
